export default {"src":"/_next/static/media/physicsBg.002842a0.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};